@if(content) {
<div class="flex flex-middle flex-justify-center bg-col-5 p-a-2">
    <img [style.height.px]="24"
         [style.width.px]="60"
         class="pos-relative"
         image="/assets/images/klarna-pink.svg">
    <span class="p2 col-11 m-l-2">{{ 'From % per month' | translate : price }}</span>
    @if(content.buttonLink && content.buttonText) {
    &nbsp;<a [routerLink]="content.buttonLink"
       class="p2 button-inline no-wrap"
       *iCms="'buttonText' of content"></a>
    }
</div>
}